import { combineReducers } from "redux";
import LayoutReducer from "./Layout/layout.slice";
import AuthReducer from "./Auth/auth.slice";
import ClinicReducer from "./Clinic/clinic.slice";
import PatientReducer from "./Patient/patient.slice";
import AlertReducer from "./Alert/alert.slice";
import SettingReducer from "./Setting/setting.slice";
import PsnAlert from "./PsnAlert/psnAlert.slice";
import ReportReducer from "./Report/report.slice";
import WatchlistReducer from "./Watchlist/watchlist.slice";
import ConsentReducer from "./Consent/consent.slice";
import DashboardReducer from "./Dashboard/dashboard.slice";
import NetworkReducer from "./Network/network.slice";
import SummaryReducer from "./Summary/summary.slice";
import HomehealthReducer from "./Homehealth/homehealth.slice";
import RTBloggerReducer from "./RTBlogger/rtBlogger.slice";
import PageSearchReducer from "./PageSearch/pageSearch.slice";
import healthScribeReducer from "./slices/healthScribeSlice";
import hpiTemplateReducer from "./HPITemplate/hpiTemplate.slice";
import portalUserInfoReducer from "./PortalUserInfo/portalUserInfo.slice";

const rootReducer = combineReducers({
  layout: LayoutReducer,
  auth: AuthReducer,
  clinic: ClinicReducer,
  patient: PatientReducer,
  alert: AlertReducer,
  settings: SettingReducer,
  psnAlert: PsnAlert,
  report: ReportReducer,
  watchlist: WatchlistReducer,
  consent: ConsentReducer,
  dashboard: DashboardReducer,
  network: NetworkReducer,
  summary: SummaryReducer,
  homehealth: HomehealthReducer,
  rtBlogger: RTBloggerReducer,
  pageSearch: PageSearchReducer,
  healthScribe: healthScribeReducer,
  hpiTemplate: hpiTemplateReducer,
  portalUserInfo: portalUserInfoReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export { rootReducer };
